import { Controller, useFormContext } from 'react-hook-form'

import { filingInstitutionIDTypes } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

export const FinancialInstitution = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.idType`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="55. Financial institution"
          input={(props) => (
            <Select
              {...props}
              data={filingInstitutionIDTypes}
              emptyOption={EMPTY_OPTION}
              data-qa="52. Primary federal regulator"
              options-data-qa="52. Primary federal regulator option"
            />
          )}
        />
      )}
    />
  )
}
